// The panel a command that confirms first opens: what it does, the serial
// typed for a factory reset, and the one button that sends it. The PoE cycle
// opens a panel of its own, chosen here. The firmware act opens none: it is the
// device page's Firmware card (#1841), and the site's table does not offer it.
//
// **The controller-direct upgrade is no longer drawn here** (ADR-0404 decisions
// 1c and 9a, built by #1816). It sent the controller's own latest image, and its
// three refusals — the qualification's (ADR-0187), the vendor line's (ADR-0259)
// and the redirector's (ADR-0389) — each offered its way through from this
// panel. The firmware act is the one act now: its candidates are the server's
// catalogued entries, each refusal's way through is drawn by
// `FirmwareAct.tsx` from the Problem's own fields exactly as it was
// here. The upgrade's endpoint left `/v1` in `0.3.13` (removed by #1834;
// #1866 ratified that release as the removal).
import { useState } from "react";
import type { useMutation } from "../../api/mutation";
import { Card, ProblemBox } from "../../ui";
import { ACTIONS, canonical, explainFor, sendCommand, type Action, type Device, type Notice } from "./commands";
import PoeCyclePanel from "./PoeCyclePanel";

export default function ActPanel({ device, action, m, onDone, onCancel }: {
  device: Device; action: Exclude<Action, "firmware_request">;
  /** The page's one write lane (#189). */
  m: ReturnType<typeof useMutation>;
  /** The command was accepted; `notice` is what to say about it. */
  onDone(notice: Notice): void;
  onCancel(): void;
}) {
  const [confirm, setConfirm] = useState("");
  // The PoE cycle confirms on a preview of the port it would cut (ADR-0300
  // decision 5b), which is a panel of its own.
  if (action === "poe_cycle") return <PoeCyclePanel device={device} m={m} onDone={onDone} onCancel={onCancel} />;
  const go = async () => {
    const notice = await sendCommand(m, device, action, confirm);
    if (notice) onDone(notice);
  };
  const a = ACTIONS[action];
  return (
    <Card className="panel" title={<>{a.title}: {device.name}</>}>
      <p className="muted">{explainFor(action, device)}</p>
      {action === "factory" && (
        <div className="field">
          <label htmlFor="factory-confirm">Type the serial <code>{device.serial}</code> to confirm</label>
          <input id="factory-confirm" autoComplete="off" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
      )}
      {m.problem && <ProblemBox problem={m.problem} />}
      <div className="actions">
        <button type="button" className={"btn " + (a.danger ? "btn-danger" : "btn-primary")}
          disabled={m.busy || (action === "factory" && canonical(confirm) !== device.serial)} onClick={() => void go()}>
          {action === "factory" ? `Reset ${device.name} to factory` : `${a.button} ${device.name}`}
        </button>
        <button type="button" className="btn" onClick={onCancel}>Cancel</button>
      </div>
    </Card>
  );
}
